import { v4 as uuidv4 } from "uuid"

const getPageDefaulWorkspaceTemplates = (record_id) => {
  return [
    {
      name: "Welcome",
      id: "welcome",
      is_static: true,
      layout: [
        {
          h: 18,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h1><br></h1><h1><strong>EDIT THIS BOX TO INCLUDE A WELCOME MESSAGE AND EXPLANATION FOR THIS WORKSPACE.</strong></h1><h1><br></h1><h1 class="ql-align-center"><strong>Example</strong>: Welcome to <em>Customer-Vendor\'s </em>shared Customer Workspace! In here we will share important information and milestones for our partnership, key dates, resources and more.</h1>',
              backgroundColor: "transparent"
            }
          },
          preserveAspectRatio: false
        },

        {
          h: 18,
          w: 72,
          x: 12,
          y: 18,
          id: uuidv4(),
          maxH: 72,
          minH: 18,
          minW: 48,
          props: {
            hidden: false,
            component_type: "calendar",
            component_props: {
              label: "Upcoming Key Events & Due Dates",
              view_by: ["plans", "goals", "tasks", "interactions"]
            },
            component_reference: "dashboard>calendar>1"
          },
          preserveAspectRatio: false
        }
      ],
      description: "A Welcome Page for your customer with relevant information."
    },
    {
      name: "Success Activities",
      id: "success_activities",
      is_static: true,
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your Success Activities! </strong></h2><h3 class="ql-align-center">Here you will find an overview of all your activities including assigned Tasks, Goals and shared Plans. </h3>',
              backgroundColor: "#6ED7F8"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 42,
          w: 72,
          x: 12,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 24,
          minW: 48,
          moved: false,
          props: {
            hidden: false,
            component_type: "action_table",
            component_props: {
              label: "Your Activities",
              view_by: ["plans", "goals", "tasks"],
              connectTo: "all_records"
            },
            component_reference: "dashboard>activities>1"
          },
          preserveAspectRatio: false
        }
      ],
      description: "Add all Goals and Tasks in one place for easy overview and access."
    },
    {
      id: "projects",
      is_static: true,
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: "  ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your Projects &amp; Plans page! </strong></h2><h3 class="ql-align-center">Find all your projects and Success Plans in one place. </h3>',
              backgroundColor: "#93D076"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 36,
          w: 72,
          x: 12,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 24,
          minW: 48,
          moved: false,
          props: {
            hidden: false,
            component_type: "action_table",
            component_props: {
              label: "Projects & Plans",
              view_by: ["plans"],
              connectTo: "all_records"
            },
            component_reference: "dashboard>activities>1"
          },
          preserveAspectRatio: false
        }
      ],
      name: "Projects",
      description: "Share projects and plans with your customers."
    },
    {
      name: "Shared Goals",
      id: "shared_goals",
      is_static: true,
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your shared Goals! </strong></h2><h3 class="ql-align-center">Here you will find an overview of all your shared Goals and all important details to achieve them.</h3>',
              backgroundColor: "#6ED7F8"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 42,
          w: 72,
          x: 12,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 24,
          minW: 48,
          moved: false,
          props: {
            hidden: false,
            component_type: "action_table",
            component_props: {
              label: "Shared Goals",
              view_by: ["goals"],
              connectTo: "all_records"
            },
            component_reference: "dashboard>activities>1"
          },
          preserveAspectRatio: false
        }
      ],
      description: "An overview of all shared Goals and milestones."
    },
    {
      name: "To Do's",
      id: "to_dos",
      is_static: true,
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your To Do\'s! </strong></h2><h3 class="ql-align-center">Here you will find an overview of all your To Do\'s so you can get things done.</h3>',
              backgroundColor: "#6ED7F8"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 42,
          w: 72,
          x: 12,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 24,
          minW: 48,
          moved: false,
          props: {
            hidden: false,
            component_type: "action_table",
            component_props: {
              label: "Your To Do's",
              view_by: ["tasks"],
              connectTo: "all_records"
            },
            component_reference: "dashboard>activities>1"
          },
          preserveAspectRatio: false
        }
      ],
      description: "An overview of all shared Tasks."
    },
    {
      name: "Customer Overview",
      id: "customer_overview",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Key details &amp; Information </strong></h2><h3 class="ql-align-center">Here you can find key details and info about our partnership, including contract details and more. </h3>',
              backgroundColor: "white"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 18,
          w: 72,
          x: 0,
          y: 30,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "assets",
            component_props: {
              label: "Important documents",
              attachments: []
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 24,
          w: 72,
          x: 0,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            hidden: false,
            component_type: "overview",
            component_props: {
              label: "Customer Info & Details",
              connectTo: "another_record",
              linkedRecord: record_id
            },
            component_reference: "dashboard>overview>2"
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: "Provide an overview of key details of your relationship with the customer."
    },
    {
      name: "Insights",
      id: "insights",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Insights </strong></h2><h3 class="ql-align-center">Welcome to the Insights page, filled with key insights and KPIs around our partnership and your Success Metrics. </h3>',
              backgroundColor: "#F0949E"
            }
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: "Share dashboards with key insights and information with your customer. "
    },
    {
      name: "Checklists",
      id: "checklists",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to the Checklists Page!</strong></h2><h3 class="ql-align-center">Use these helpful checklist to keep track of everything that we are doing together.</h3>',
              backgroundColor: "#F0949E"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 42,
          w: 72,
          x: 0,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            hidden: false,
            component_type: "checklist",
            component_props: {
              label: "All Checklists",
              connectTo: "another_record",
              linkedRecord: record_id
            },
            component_reference: "dashboard>checklist>1"
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: `Use Checklists, like an "Onboarding Checklist", to streamline important items.`
    },
    {
      name: "Documents & files",
      id: "documents_and_files",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your Resources page!</strong></h2><h3 class="ql-align-center">Here you will find all the important documents and files that have been shared with your team. </h3>',
              backgroundColor: "white"
            }
          },
          preserveAspectRatio: false
        },
        {
          h: 36,
          w: 72,
          x: 0,
          y: 6,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "assets",
            component_props: {
              label: "All documents and files",
              attachments: []
            }
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: "Share documents, files and links with your customers."
    },
    {
      name: "Health & Usage",
      id: "health_and_usage",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: " ",
              description:
                '<h2 class="ql-align-center"><strong>Welcome to your Usage page!</strong></h2><h3 class="ql-align-center">Here you will find and can keep track of key usage &amp; health metrics related to your account. </h3>',
              backgroundColor: "#93D076"
            }
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: "Showcase the key metrics and insights you have about the customers usage, adoption & health."
    },
    {
      name: "Meet your Team",
      id: "meet_your_team",
      layout: [
        {
          h: 6,
          w: 72,
          x: 0,
          y: 0,
          id: uuidv4(),
          maxH: 72,
          minH: 6,
          minW: 6,
          moved: false,
          props: {
            component_type: "text",
            component_props: {
              label: "  ",
              description:
                '<h2 class="ql-align-center"><strong>Meet your Team!</strong></h2><h3 class="ql-align-center">We are excited to work with you! Here you  can find contact details and information about your team.</h3>',
              backgroundColor: "rgb(226 232 240)"
            }
          },
          preserveAspectRatio: false
        }
      ],
      is_static: true,
      description: "Introduce the customer to the team members that they work with. "
    }
  ]
}

const getWorkspaceTemplates = () => {
  return [
    {
      is_static: true,
      name: "Superman Template",
      id: "superman",
      description: "Your sales will fly soooo sooooo high with this template",
      pages: [
        {
          name: "Success Activities",
          id: "success_activities",
          is_visible: true,
          layout: [
            {
              h: 24,
              w: 72,
              x: 0,
              y: 0,
              id: uuidv4(),
              maxH: 72,
              minH: 24,
              minW: 48,
              moved: false,
              props: {
                hidden: false,
                component_type: "action_table",
                component_props: {
                  label: "Activity Table",
                  view_by: ["goals", "tasks"],
                  connectTo: "all_records"
                },
                component_reference: "dashboard>actions>0"
              },
              preserveAspectRatio: false
            }
          ]
        }
      ]
    }
  ]
}
export { getWorkspaceTemplates, getPageDefaulWorkspaceTemplates }
